<label class="ui-checkbox ui-checkbox-primary">
    <input type="checkbox" #checkbox [checked]="checkboxValue" (click)="toggleCheckbox()" />
    <span class="input-span"></span>
  </label>
  